// extracted by mini-css-extract-plugin
export default {"summary":"Summary-module__summary--v3IQV","statWithMarginBottom":"Summary-module__statWithMarginBottom--ykSIa","fixedStatValue":"Summary-module__fixedStatValue--vzv1_"};